import EmailAddressFormPanel from './EmailAddressFormPanel';

export default EmailAddressFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/EmailAddressFormPanel/index.js